// src/locales/ko.ts — Korean
import type { TranslationKey } from './en'

const ko: Record<TranslationKey, string> = {
  // Navigation
  'nav.dashboard': '\ub300\uc2dc\ubcf4\ub4dc',
  'nav.tests': '\uc2dc\ud5d8',
  'nav.sat': 'SAT',
  'nav.psat': 'PSAT',
  'nav.act': 'ACT',
  'nav.practice': '\uc5f0\uc2b5',
  'nav.learn': '\ud559\uc2b5',
  'nav.videos': '동영상',
  'nav.bookmarks': '\ubd81\ub9c8\ud06c',
  'nav.pricing': '\uc694\uae08',
  'nav.groups': '\uadf8\ub8f9',
  'nav.signIn': '\ub85c\uadf8\uc778',
  'nav.signOut': '\ub85c\uadf8\uc544\uc6c3',

  // Dashboard
  'dashboard.welcomeBack': '\ub2e4\uc2dc \uc624\uc2e0 \uac83\uc744 \ud658\uc601\ud569\ub2c8\ub2e4',
  'dashboard.scorePrediction': '\uc810\uc218 \uc608\uce21',
  'dashboard.studyPlan': '\ud559\uc2b5 \uacc4\ud68d',
  'dashboard.quickDrill': '\ube60\ub978 \uc5f0\uc2b5',
  'dashboard.inviteFriends': '\uce5c\uad6c \ucd08\ub300',

  // Common
  'common.start': '\uc2dc\uc791',
  'common.resume': '\uacc4\uc18d',
  'common.retake': '\ub2e4\uc2dc \uc2dc\ud5d8',
  'common.submit': '\uc81c\ucd9c',
  'common.next': '\ub2e4\uc74c',
  'common.previous': '\uc774\uc804',
  'common.cancel': '\ucde8\uc18c',
  'common.save': '\uc800\uc7a5',
  'common.loading': '\ub85c\ub529 \uc911',

  // Results
  'results.score': '\uc810\uc218',
  'results.correct': '\uc815\ub2f5',
  'results.incorrect': '\uc624\ub2f5',
  'results.time': '\uc2dc\uac04',
  'results.viewResults': '\uacb0\uacfc \ubcf4\uae30',
  'results.downloadPdf': 'PDF \ub2e4\uc6b4\ub85c\ub4dc',
  'results.share': '\uacf5\uc720',

  // Practice
  'practice.byTopic': '\uc8fc\uc81c\ubcc4 \uc5f0\uc2b5',
  'practice.checkAnswer': '\ub2f5 \ud655\uc778',
  'practice.explanation': '\ud574\uc124',

  // Pricing
  'pricing.freePlan': '\ubb34\ub8cc \ud50c\ub79c',
  'pricing.proPlan': 'PRO \ud50c\ub79c',
  'pricing.upgrade': '\uc5c5\uadf8\ub808\uc774\ub4dc',
  'pricing.monthly': '\uc6d4\uac04',
  'pricing.testsPerMonth': '\uc6d4\ubcc4 \uc2dc\ud5d8 \ud69f\uc218',
  'pricing.unlimited': '\ubb34\uc81c\ud55c',

  // Language selector
  'language.label': '\uc5b8\uc5b4',
}

export default ko
